// extracted by mini-css-extract-plugin
export var filterIncDec = "_cw-0";
export var leftBorder = "_cw-1";
export var rightBorder = "_cw-2";
export var stringInput = "_cw-3";